export default __webpack_public_path__ + "buying-power-credit-banner.svg?cc5b9d878f20988f17a9bcfc831c76be";